import { NewRelicPlusPlugin, EventType, ElementType, EventAction } from '@cof/stratum';

const PLUGINS = [NewRelicPlusPlugin()];
// PRODUCT_NAME is a required export of this file (use your DevNav component name)
const PRODUCT_NAME = 'fs-creditpull-mfe-staticassets';
// PRODUCT_VERSION is a required export of this file
const PRODUCT_VERSION = '0.0.0';
var TagKey;
(function (TagKey) {
    /**
     * Enumerate keys of tag catalog entries here for easy
     * use and consistent reference across your application.
     *
     * The values of the tag keys can be any string or number
     * value. These keys will not be referenced outside
     * of the application.
     */
    TagKey["PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL"] = "PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL";
    TagKey["HARDPULL_CHOOSE_A_DIFFERENT_OFFER"] = "HARDPULL_CHOOSE_A_DIFFERENT_OFFER";
    TagKey["HARDPULL_HARDPULL_CONSENT_CHECKED"] = "HARDPULL_HARDPULL_CONSENT_CHECKED";
    TagKey["HARDPULL_SUBMIT_HARDPULL_APPLICATION"] = "HARDPULL_SUBMIT_HARDPULL_APPLICATION";
    TagKey["PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL_PROCESSING"] = "PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL_PROCESSING";
    TagKey["PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL_DECLINED"] = "PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL_DECLINED";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_CREDITPULL"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_CREDITPULL";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_CREDITPULL_2"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_CREDITPULL_2";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PROCESSING"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PROCESSING";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_NO_OFFER"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_NO_OFFER";
    TagKey["PQ_REVIEW_PQ_REVIEW_CONSENT"] = "PQ_REVIEW_PQ_REVIEW_CONSENT";
    TagKey["PQ_REVIEW_PQ_REVIEW_TC_EXPAND"] = "PQ_REVIEW_PQ_REVIEW_TC_EXPAND";
    TagKey["PQ_REVIEW_PQ_REVIEW_TC_FAQ_OPENED"] = "PQ_REVIEW_PQ_REVIEW_TC_FAQ_OPENED";
    TagKey["PQ_REVIEW_PQ_REVIEW_TC_PRIVACY_POLICIES"] = "PQ_REVIEW_PQ_REVIEW_TC_PRIVACY_POLICIES";
    TagKey["PQ_REVIEW_PQ_REVIEW_TC_ELECTRONIC_DELIVERY_NOTICE"] = "PQ_REVIEW_PQ_REVIEW_TC_ELECTRONIC_DELIVERY_NOTICE";
    TagKey["SECURITY_QUIZ_SECURITY_QUIZ_SHOWN"] = "SECURITY_QUIZ_SECURITY_QUIZ_SHOWN";
    TagKey["SECURITY_QUIZ_SECURITY_QUIZ_ANSWER_SUBMIT"] = "SECURITY_QUIZ_SECURITY_QUIZ_ANSWER_SUBMIT";
    TagKey["SECURITY_QUIZ_SECURITY_QUIZ_PASSED"] = "SECURITY_QUIZ_SECURITY_QUIZ_PASSED";
    TagKey["SECURITY_QUIZ_SECURITY_QUIZ_FAILED"] = "SECURITY_QUIZ_SECURITY_QUIZ_FAILED";
    TagKey["PREQUAL_SUBMIT_APPLIED_WITH_PA_CODE"] = "PREQUAL_SUBMIT_APPLIED_WITH_PA_CODE";
    TagKey["PREQUAL_SUBMIT_PREQUAL_SUBMIT_ERROR"] = "PREQUAL_SUBMIT_PREQUAL_SUBMIT_ERROR";
    TagKey["PREQUAL_SUBMIT_PREQUAL_SUBMIT_PROCESSING_TIME"] = "PREQUAL_SUBMIT_PREQUAL_SUBMIT_PROCESSING_TIME";
    TagKey["BANDIT_SUBMITTED_BANDIT_FEEDBACK"] = "BANDIT_SUBMITTED_BANDIT_FEEDBACK";
    TagKey["BANDIT_FAILED_BANDIT_FEEDBACK"] = "BANDIT_FAILED_BANDIT_FEEDBACK";
    TagKey["VIEW_ICONIC_HARDPULL"] = "VIEW_ICONIC_HARDPULL";
    TagKey["ICONIC_HARDPULL_OKAY_GOT_IT_CLICKED"] = "ICONIC_HARDPULL_OKAY_GOT_IT_CLICKED";
    TagKey["ICONIC_HARDPULL_HARDPULL_CONSENT_AND_SUBMIT"] = "ICONIC_HARDPULL_HARDPULL_CONSENT_AND_SUBMIT";
    TagKey["ICONIC_HARDPULL_HARDPULL_CONSENT_MODAL_CLOSE"] = "ICONIC_HARDPULL_HARDPULL_CONSENT_MODAL_CLOSE";
    TagKey["ICONIC_HARDPULL_RETURN_TO_CAPITAL_ONE"] = "ICONIC_HARDPULL_RETURN_TO_CAPITAL_ONE";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VERIFYING"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VERIFYING";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_REVIEWING"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_REVIEWING";
    TagKey["VERIFYING_CALL_US_TO_VERIFY"] = "VERIFYING_CALL_US_TO_VERIFY";
    TagKey["PQ_DECLINE_EXIT_APP_AFTER_DECLINE"] = "PQ_DECLINE_EXIT_APP_AFTER_DECLINE";
    TagKey["REVIEWING_EXIT_APP_AFTER_REVIEWING"] = "REVIEWING_EXIT_APP_AFTER_REVIEWING";
    TagKey["HARDPULL_PRIMER_CONTINUE_TO_CREDIT_PULL"] = "HARDPULL_PRIMER_CONTINUE_TO_CREDIT_PULL";
    TagKey["VIEW_HARDPULL_PRIMER"] = "VIEW_HARDPULL_PRIMER";
    TagKey["HARDPULL_PRIMER_HARDPULL_PRIMER_CONSENT_AND_SUBMIT"] = "HARDPULL_PRIMER_HARDPULL_PRIMER_CONSENT_AND_SUBMIT";
    TagKey["HARDPULL_PRIMER_HARDPULL_PRIMER_CONSENT_MODAL_CLOSE"] = "HARDPULL_PRIMER_HARDPULL_PRIMER_CONSENT_MODAL_CLOSE";
    TagKey["PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL_2"] = "PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL_2";
    TagKey["COMBINED_HP_AND_CONTRACT_CONTINUE_TO_AGREEMENT"] = "COMBINED_HP_AND_CONTRACT_CONTINUE_TO_AGREEMENT";
    TagKey["PAGE_VIEW_COAF_REFI_CREDITPULL_DELAYED_HARDPULL_PRIMER"] = "PAGE_VIEW_COAF_REFI_CREDITPULL_DELAYED_HARDPULL_PRIMER";
    TagKey["DELAYED_HARDPULL_PRIMER_CONTINUE_CLICKED"] = "DELAYED_HARDPULL_PRIMER_CONTINUE_CLICKED";
    TagKey["PAGE_VIEW_COAF_REFI_CREDITPULL_DELAYED_HARDPULL_CONSENT"] = "PAGE_VIEW_COAF_REFI_CREDITPULL_DELAYED_HARDPULL_CONSENT";
    TagKey["DELAYED_HARDPULL_CONSENT_CONTINUE_TO_CONSENT_CLICKED"] = "DELAYED_HARDPULL_CONSENT_CONTINUE_TO_CONSENT_CLICKED";
    TagKey["VIEW_DELAYED_HARDPULL_MODAL"] = "VIEW_DELAYED_HARDPULL_MODAL";
    TagKey["DELAYED_HARDPULL_MODAL_I_AGREE_CLICKED"] = "DELAYED_HARDPULL_MODAL_I_AGREE_CLICKED";
    TagKey["DELAYED_HARDPULL_MODAL_MODAL_CLOSED"] = "DELAYED_HARDPULL_MODAL_MODAL_CLOSED";
    TagKey["DELAYED_HARDPULL_CONSENT_SUBMIT_HARDPULL_CONSENT_SUBMIT_SUCCESSFUL"] = "DELAYED_HARDPULL_CONSENT_SUBMIT_HARDPULL_CONSENT_SUBMIT_SUCCESSFUL";
    TagKey["DELAYED_HARDPULL_CONSENT_SUBMIT_HARDPULL_CONSENT_SUBMIT_FAILURE"] = "DELAYED_HARDPULL_CONSENT_SUBMIT_HARDPULL_CONSENT_SUBMIT_FAILURE";
    TagKey["HARDPULL_PRIMER_COAPP_CONSENT_AND_SUBMIT"] = "HARDPULL_PRIMER_COAPP_CONSENT_AND_SUBMIT";
    TagKey["VIEW_DELAYED_HARDPULL_COBORROWER_MODAL"] = "VIEW_DELAYED_HARDPULL_COBORROWER_MODAL";
    TagKey["DELAYED_HARDPULL_COBORROWER_MODAL_WE_AGREE_CLICKED"] = "DELAYED_HARDPULL_COBORROWER_MODAL_WE_AGREE_CLICKED";
    TagKey["DELAYED_HARDPULL_COBORROWER_MODAL_MODAL_CLOSED"] = "DELAYED_HARDPULL_COBORROWER_MODAL_MODAL_CLOSED";
    TagKey["OTP_VIEW_PHONE_VERIFICATION"] = "OTP_VIEW_PHONE_VERIFICATION";
    TagKey["OTP_SEND_CODE_CLICKED"] = "OTP_SEND_CODE_CLICKED";
    TagKey["OTP_VERIFY_ANOTHER_WAY_CLICKED"] = "OTP_VERIFY_ANOTHER_WAY_CLICKED";
    TagKey["OTP_VERIFY_ANOTHER_WAY_VIEWED"] = "OTP_VERIFY_ANOTHER_WAY_VIEWED";
    TagKey["OTP_VERIFYING_CALL_US_CLICKED"] = "OTP_VERIFYING_CALL_US_CLICKED";
    TagKey["OTP_ENTER_CODE_VIEWED"] = "OTP_ENTER_CODE_VIEWED";
    TagKey["OTP_RESEND_CODE_CLICKED"] = "OTP_RESEND_CODE_CLICKED";
    TagKey["OTP_SUBMIT_CODE_CLICKED"] = "OTP_SUBMIT_CODE_CLICKED";
    TagKey["OTP_USE_A_NEW_NUMBER_CLICKED"] = "OTP_USE_A_NEW_NUMBER_CLICKED";
    TagKey["OTP_FIELD_ERROR_MESSAGE"] = "OTP_FIELD_ERROR_MESSAGE";
    TagKey["OTP_OTP_PASSED"] = "OTP_OTP_PASSED";
    TagKey["OTP_OTP_FAILED"] = "OTP_OTP_FAILED";
    TagKey["OTP_LEARN_MORE_CLICKED"] = "OTP_LEARN_MORE_CLICKED";
    TagKey["OTP_LEARN_MORE_VIEWED"] = "OTP_LEARN_MORE_VIEWED";
    TagKey["OTP_LEARN_MORE_MODAL_CLOSED"] = "OTP_LEARN_MORE_MODAL_CLOSED";
})(TagKey || (TagKey = {}));
// TAG_CATALOG is a required export of this file
const TAG_CATALOG = {
    /**
     * Add TagCatalog entries here. Best practice
     * is to use enumerated values for the tag keys.
     *
     * For properties with values of a specific type (like eventType),
     * export the corresponding type from the @cof/stratum package.
     */
    [TagKey.PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Hardpull Page Viewed',
        tagId: 4001,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'creditpull',
            level4: 'hardpull',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.HARDPULL_CHOOSE_A_DIFFERENT_OFFER]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Choose a different offer" from link under review offer section',
        tagId: 4002,
        rules: {
            applicationId: true,
        },
        featureName: 'Hardpull',
        tagName: 'choose a different offer',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.HARDPULL_HARDPULL_CONSENT_CHECKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "hardpull consent" checkbox',
        tagId: 4003,
        rules: {
            applicationId: true,
        },
        featureName: 'Hardpull',
        tagName: 'hardpull consent checked',
        elementType: ElementType.CHECKBOX,
        action: EventAction.CHECK,
    },
    [TagKey.HARDPULL_SUBMIT_HARDPULL_APPLICATION]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Submit Credit Application" button at bottom',
        tagId: 4004,
        rules: {
            applicationId: true,
        },
        featureName: 'Hardpull',
        tagName: 'submit hardpull application',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL_PROCESSING]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Hardpull Processing Page Viewed',
        tagId: 4005,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'creditpull',
            level4: 'hardpull',
            level5: 'processing',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL_DECLINED]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Hardpull Decline Page Viewed',
        tagId: 4006,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'creditpull',
            level4: 'hardpull',
            level5: 'declined',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_CREDITPULL]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'PQ Submit Page',
        tagId: 4007,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'creditpull',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_CREDITPULL_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod PQ Submit step is shown',
        tagId: 4008,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'creditpull',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PROCESSING]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'PQ Processing Application Page',
        tagId: 4009,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'processing',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_NO_OFFER]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'PQ Decline Page',
        tagId: 4010,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'no-offer',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PQ_REVIEW_PQ_REVIEW_CONSENT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks checkbox to agree to PQ review terms and conditions',
        tagId: 4011,
        featureName: 'PQ review',
        tagName: 'pq review consent',
        elementType: ElementType.CHECKBOX,
        action: EventAction.CHECK,
    },
    [TagKey.PQ_REVIEW_PQ_REVIEW_TC_EXPAND]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks link to expand "Show more terms and conditions"',
        tagId: 4012,
        featureName: 'PQ review',
        tagName: 'pq review tc expand',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.PQ_REVIEW_PQ_REVIEW_TC_FAQ_OPENED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks link to open "Learn more about what you\'re agreeing to (FAQ)',
        tagId: 4013,
        featureName: 'PQ review',
        tagName: 'pq review tc faq opened',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.PQ_REVIEW_PQ_REVIEW_TC_PRIVACY_POLICIES]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks link "Capital One Privacy Policies"',
        tagId: 4014,
        featureName: 'PQ review',
        tagName: 'pq review tc privacy policies',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.PQ_REVIEW_PQ_REVIEW_TC_ELECTRONIC_DELIVERY_NOTICE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks link "Electronic Delivery of Disclosure Notice"',
        tagId: 4015,
        featureName: 'PQ review',
        tagName: 'pq review tc electronic delivery notice',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.SECURITY_QUIZ_SECURITY_QUIZ_SHOWN]: {
        eventType: EventType.UI,
        tagDescription: 'Security quiz was triggered and shown to applicant',
        tagId: 4016,
        featureName: 'security quiz',
        tagName: 'security quiz shown',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD,
    },
    [TagKey.SECURITY_QUIZ_SECURITY_QUIZ_ANSWER_SUBMIT]: {
        eventType: EventType.UI,
        tagDescription: 'Security quiz was triggered and submitted by applicant',
        tagId: 4017,
        featureName: 'security quiz',
        tagName: 'security quiz answer submit',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD,
    },
    [TagKey.SECURITY_QUIZ_SECURITY_QUIZ_PASSED]: {
        eventType: EventType.UI,
        tagDescription: 'Security quiz was triggered and passed by applicant',
        tagId: 4018,
        featureName: 'security quiz',
        tagName: 'security quiz passed',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD,
    },
    [TagKey.SECURITY_QUIZ_SECURITY_QUIZ_FAILED]: {
        eventType: EventType.UI,
        tagDescription: 'Security quiz was triggered and failed by applicant',
        tagId: 4019,
        featureName: 'security quiz',
        tagName: 'security quiz failed',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD,
    },
    [TagKey.PREQUAL_SUBMIT_APPLIED_WITH_PA_CODE]: {
        eventType: EventType.UI,
        tagDescription: 'Customer applied usng a PA offer code',
        tagId: 4020,
        featureName: 'prequal submit',
        tagName: 'applied with pa code',
        elementType: ElementType.MESSAGE,
        action: EventAction.LOAD,
    },
    [TagKey.PREQUAL_SUBMIT_PREQUAL_SUBMIT_ERROR]: {
        eventType: EventType.UI,
        tagDescription: 'Prequal failed to submit and error message was shown',
        tagId: 4021,
        featureName: 'prequal submit',
        tagName: 'prequal submit error',
        elementType: ElementType.MESSAGE,
        action: EventAction.LOAD,
    },
    [TagKey.PREQUAL_SUBMIT_PREQUAL_SUBMIT_PROCESSING_TIME]: {
        eventType: EventType.UI,
        tagDescription: 'Prequal failed to submit due to long processing time ',
        tagId: 4022,
        featureName: 'prequal submit',
        tagName: 'prequal submit processing time',
        elementType: ElementType.MESSAGE,
        action: EventAction.LOAD,
    },
    [TagKey.BANDIT_SUBMITTED_BANDIT_FEEDBACK]: {
        eventType: EventType.UI,
        tagDescription: 'bandit feedback was submitted successfully',
        tagId: 4023,
        featureName: 'bandit',
        tagName: 'submitted bandit feedback',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.BANDIT_FAILED_BANDIT_FEEDBACK]: {
        eventType: EventType.UI,
        tagDescription: 'bandit feedback failed to submit',
        tagId: 4024,
        featureName: 'bandit',
        tagName: 'failed bandit feedback',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VIEW_ICONIC_HARDPULL]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Iconic Hardpull Consent Modal Viewed',
        tagId: 4025,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Hardpull',
    },
    [TagKey.ICONIC_HARDPULL_OKAY_GOT_IT_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "Okay, got it" on the hardpull submit page',
        tagId: 4026,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Hardpull',
        tagName: 'okay got it clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_HARDPULL_HARDPULL_CONSENT_AND_SUBMIT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "I agree" in the hardpull consent modal- initating hardpull',
        tagId: 4027,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Hardpull',
        tagName: 'hardpull consent and submit',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_HARDPULL_HARDPULL_CONSENT_MODAL_CLOSE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "X" in the hardpull consent modal',
        tagId: 4028,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Hardpull',
        tagName: 'hardpull consent modal close',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_HARDPULL_RETURN_TO_CAPITAL_ONE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "Return to Capital One" on Iconic Hardpull decline screen',
        tagId: 4029,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Hardpull',
        tagName: 'return to capital one',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VERIFYING]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'PQ Verifying Page',
        tagId: 4031,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'verifying',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_REVIEWING]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'PQ Reviewing Page',
        tagId: 4032,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'reviewing',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.VERIFYING_CALL_US_TO_VERIFY]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks CTA "Call us at 1.888.263.4582 "on Verifying Page',
        tagId: 4033,
        featureName: 'Verifying',
        tagName: 'Call us to verify',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PQ_DECLINE_EXIT_APP_AFTER_DECLINE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks CTA "Return to Capital One" on PQ decline page',
        tagId: 4034,
        featureName: 'PQ decline',
        tagName: 'exit app after decline',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.REVIEWING_EXIT_APP_AFTER_REVIEWING]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks CTA "Return to Capital One" on Reviewing page',
        tagId: 4035,
        featureName: 'Reviewing',
        tagName: 'exit app after reviewing',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.HARDPULL_PRIMER_CONTINUE_TO_CREDIT_PULL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Continue to credit pull" on hard pull primer page',
        tagId: 4036,
        rules: {
            applicationId: true,
        },
        featureName: 'Hardpull Primer',
        tagName: 'continue to credit pull',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.VIEW_HARDPULL_PRIMER]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Hardpull Primer Consent Modal Viewed',
        tagId: 4037,
        rules: {
            applicationId: true,
        },
        featureName: 'Hardpull Primer',
    },
    [TagKey.HARDPULL_PRIMER_HARDPULL_PRIMER_CONSENT_AND_SUBMIT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "I agree" in the hardpull primer consent modal- initating hardpull',
        tagId: 4038,
        rules: {
            applicationId: true,
        },
        featureName: 'Hardpull Primer',
        tagName: 'hardpull primer consent and submit',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.HARDPULL_PRIMER_HARDPULL_PRIMER_CONSENT_MODAL_CLOSE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "X" in the hardpull primer consent modal',
        tagId: 4039,
        rules: {
            applicationId: true,
        },
        featureName: 'Hardpull Primer',
        tagName: 'hardpull primer consent modal close',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_CREDITPULL_HARDPULL_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Combined Hardpull and Contract Primer Page Viewed',
        tagId: 4040,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'creditpull',
            level4: 'hardpull',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.COMBINED_HP_AND_CONTRACT_CONTINUE_TO_AGREEMENT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Continue to agreement" in the Combined Hardpull and Contract Primer Page',
        tagId: 4041,
        rules: {
            applicationId: true,
        },
        featureName: 'Combined HP and Contract',
        tagName: 'continue to agreement',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_CREDITPULL_DELAYED_HARDPULL_PRIMER]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Delayed Hardpull Primer Page Viewed',
        tagId: 4042,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'creditpull',
            level4: 'delayed-hardpull-primer',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.DELAYED_HARDPULL_PRIMER_CONTINUE_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "Continue" on Delayed Hardpull Primer Page',
        tagId: 4043,
        rules: {
            applicationId: true,
        },
        featureName: 'delayed hardpull primer',
        tagName: 'continue clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_CREDITPULL_DELAYED_HARDPULL_CONSENT]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Delayed Hardpull Consent Page Viewed',
        tagId: 4044,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'creditpull',
            level4: 'delayed-hardpull-consent',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.DELAYED_HARDPULL_CONSENT_CONTINUE_TO_CONSENT_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "Continue to consent" on the Delayed Hardpull Consent Page',
        tagId: 4045,
        rules: {
            applicationId: true,
        },
        featureName: 'delayed hardpull consent',
        tagName: 'continue to consent clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.VIEW_DELAYED_HARDPULL_MODAL]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Delayed Hardpull Consent Modal Viewed',
        tagId: 4046,
        rules: {
            applicationId: true,
        },
        featureName: 'delayed hardpull modal',
    },
    [TagKey.DELAYED_HARDPULL_MODAL_I_AGREE_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "I agree" on the Delayed Hardpull Consent Modal',
        tagId: 4047,
        rules: {
            applicationId: true,
        },
        featureName: 'delayed hardpull modal',
        tagName: 'I agree clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.DELAYED_HARDPULL_MODAL_MODAL_CLOSED]: {
        eventType: EventType.UI,
        tagDescription: 'Delayed Hardpull Consent Modal Closed',
        tagId: 4048,
        rules: {
            applicationId: true,
        },
        featureName: 'delayed hardpull modal',
        tagName: 'modal closed',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD,
    },
    [TagKey.DELAYED_HARDPULL_CONSENT_SUBMIT_HARDPULL_CONSENT_SUBMIT_SUCCESSFUL]: {
        eventType: EventType.UI,
        tagDescription: 'Hardpull consent was submitted successfully',
        tagId: 4049,
        rules: {
            applicationId: true,
        },
        featureName: 'delayed hardpull consent submit',
        tagName: 'hardpull consent submit successful',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD,
    },
    [TagKey.DELAYED_HARDPULL_CONSENT_SUBMIT_HARDPULL_CONSENT_SUBMIT_FAILURE]: {
        eventType: EventType.UI,
        tagDescription: 'Hardpull consent submission error (value is error)',
        tagId: 4050,
        rules: {
            applicationId: true,
        },
        featureName: 'delayed hardpull consent submit',
        tagName: 'hardpull consent submit failure',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD,
        value: '${value}',
    },
    [TagKey.HARDPULL_PRIMER_COAPP_CONSENT_AND_SUBMIT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "We agree" in the CoApp hardpull consent modal- initating hardpull',
        tagId: 4051,
        rules: {
            applicationId: true,
        },
        featureName: 'Hardpull Primer',
        tagName: 'coapp consent and submit',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.VIEW_DELAYED_HARDPULL_COBORROWER_MODAL]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Delayed Hardpull Coborrower Consent Modal Viewed',
        tagId: 4052,
        rules: {
            applicationId: true,
        },
        featureName: 'delayed hardpull coborrower modal',
    },
    [TagKey.DELAYED_HARDPULL_COBORROWER_MODAL_WE_AGREE_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "We agree" on the Delayed Hardpull Coborrower Consent Modal',
        tagId: 4053,
        rules: {
            applicationId: true,
        },
        featureName: 'delayed hardpull coborrower modal',
        tagName: 'We agree clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.DELAYED_HARDPULL_COBORROWER_MODAL_MODAL_CLOSED]: {
        eventType: EventType.UI,
        tagDescription: 'Delayed Hardpull Coborrower Consent Modal Closed',
        tagId: 4054,
        rules: {
            applicationId: true,
        },
        featureName: 'delayed hardpull coborrower modal',
        tagName: 'modal closed',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD
    },
    [TagKey.OTP_VIEW_PHONE_VERIFICATION]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'OTP Phone Verification Page',
        tagId: 4056,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'creditpull',
            level4: 'one-time-passcode',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.OTP_SEND_CODE_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on “Send code” CTA on OTP phone verification page',
        tagId: 4057,
        featureName: 'one-time-passcode',
        tagName: 'send code clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.OTP_VERIFY_ANOTHER_WAY_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on “Verify another way” CTA on OTP phone verification page',
        tagId: 4058,
        featureName: 'one-time-passcode',
        tagName: 'verify another way clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.OTP_VERIFY_ANOTHER_WAY_VIEWED]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: '"Verify another way" modal viewed',
        tagId: 4059,
        featureName: 'one-time-passcode'
    },
    [TagKey.OTP_VERIFYING_CALL_US_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks CTA "Call 888-263-4582 "on OTP phone verification page',
        tagId: 4060,
        featureName: 'one-time-passcode',
        tagName: 'verify by phone',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.OTP_ENTER_CODE_VIEWED]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'OTP Code Entry Page',
        tagId: 4061,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'creditpull',
            level4: 'one-time-passcode',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.OTP_RESEND_CODE_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on “Resend code” CTA on OTP code entry page',
        tagId: 4062,
        featureName: 'one-time-passcode',
        tagName: 'resend code clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.OTP_SUBMIT_CODE_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on “Submit code” CTA on OTP code entry page',
        tagId: 4063,
        featureName: 'one-time-passcode',
        tagName: 'submit code clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.OTP_USE_A_NEW_NUMBER_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on “Use a new mobile number” CTA on OTP code entry page',
        tagId: 4064,
        featureName: 'one-time-passcode',
        tagName: 'use a new mobile number clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.OTP_FIELD_ERROR_MESSAGE]: {
        eventType: EventType.UI,
        tagDescription: 'User receives invalid field criteria message',
        tagId: 4065,
        featureName: 'one-time-passcode',
        tagName: 'otp error message',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR
    },
    [TagKey.OTP_OTP_PASSED]: {
        eventType: EventType.UI,
        tagDescription: 'Applicant passed otp',
        tagId: 4066,
        featureName: 'one-time-passcode',
        tagName: 'otp passed',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT
    },
    [TagKey.OTP_OTP_FAILED]: {
        eventType: EventType.UI,
        tagDescription: 'Applicant failed otp',
        tagId: 4067,
        featureName: 'one-time-passcode',
        tagName: 'otp failed',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT
    },
    [TagKey.OTP_LEARN_MORE_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on “Learn More” CTA on OTP phone verification page',
        tagId: 4068,
        featureName: 'one-time-passcode',
        tagName: 'learn more clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.OTP_LEARN_MORE_VIEWED]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: '"Learn More" modal viewed',
        tagId: 4069,
        featureName: 'one-time-passcode'
    },
    [TagKey.OTP_LEARN_MORE_MODAL_CLOSED]: {
        eventType: EventType.UI,
        tagDescription: '"Learn More" modal dismissed',
        tagId: 4070,
        featureName: 'one-time-passcode',
        tagName: 'user closes the learn more modal',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    }
};

export { PLUGINS, PRODUCT_NAME, PRODUCT_VERSION, TAG_CATALOG, TagKey };
